import requests from "./requests";

export default {
	getMembershipStatus,
};

async function getMembershipStatus(token) {
	try {
		let status = await requests.get("/membershiprenewal/status", { token });

		return status;
	} catch (err) {
		throw err;
	}
}
